import { useTranslation } from "react-i18next";
import { FormSectionComponent } from "./FormSectionComponent";
import { Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { FormKeys } from "../helpers";
import { NumericFormat } from "react-number-format";
import { CustomInput } from "./components/CustomInput";
import {
  WORK_AGREEMENT_ACCEPTED,
  WORK_AGREEMENT_DECLINED,
} from "../../../../constants";
import { SalaryType } from "../../../../types/salaryType";
import InfoTooltip from "../../../../../../common/components/functional/InfoTooltip/InfoTooltip";

export const OverrideBillingPrice = () => {
  const { t } = useTranslation();
  const { control, getValues, watch } = useFormContext();

  const isMonthlySalary = watch(FormKeys.SalaryType) === SalaryType.Monthly;
  const status = getValues("status");
  const isReadOnly: boolean =
    status === WORK_AGREEMENT_ACCEPTED || status === WORK_AGREEMENT_DECLINED;

  const title = isMonthlySalary
    ? t("order:billMonthlySalaryAsHourlyTitle")
    : t("order:fixedNonStandardBillingPriceTitle");
  const guideText = isMonthlySalary
    ? ""
    : t("order:fixedNonStandardBillingPriceGuideText");
  const infoTooltip = isMonthlySalary ? (
    <InfoTooltip
      title={t("order:billMonthlySalaryAsHourlyGuideText")}
      style={{ marginLeft: "8px" }}
    />
  ) : undefined;

  const rows = [
    {
      title: "",
      component: <Typography>{guideText}</Typography>,
    },
    {
      title: t("talentProfile:pricing"),
      component: (
        <Controller
          control={control}
          name={FormKeys.InvoicingPriceOverride}
          render={({ field: { value, onChange } }) => (
            <>
              <NumericFormat
                value={value}
                onValueChange={(values) => onChange(values.value)}
                valueIsNumericString
                allowNegative={false}
                decimalSeparator=","
                decimalScale={2}
                customInput={CustomInput}
                disabled={isReadOnly}
              />
              <Typography alignSelf="center" paddingLeft="0.5rem">
                {t("common:hourlySalaryUnit")}
              </Typography>
            </>
          )}
        />
      ),
    },
  ];

  return (
    <FormSectionComponent title={title} rows={rows} infoTooltip={infoTooltip} />
  );
};
